import FilterSet from '@/lib/store/FilterSet'

const filters = new FilterSet()

filters.addFilter ('leads', { inProgress: false, period: 90 })

export default { ...filters.getModule() }
